import { useTabs } from '@Pages/Admin/tabs';
import { useMemo } from 'react';

export default function useGetIntegrationsIndex(query: RegExp) {
	const tabs = useTabs({});
	const selectedIndex = useMemo(() => {
		return tabs.findIndex(tab => query.test(tab.to || ''));
	}, [tabs, query]);
	return selectedIndex;
}
